export default __webpack_public_path__ + "static/phonesmart-licence-ffaf08db4e9f05058fdd4599aecd1fc1.png";